export const baseURL = 'https://api.spinmyride.net/';
export const uploadURL = baseURL + 'uploads/';

//higer value means less sensitivity
export const sensitivity = 20;
